
<template>
  <div>
    <label class="text-sm opacity-75">{{ $t('filters.' + filter.title + '.title') }}</label>
    <ul>
      <li class="mb-2 flex items-center justify-between">
        <vs-switch color="success"  v-model="selected"></vs-switch>
      </li>
    </ul>
  </div>
</template>

<script>


export default {
  name: 'sm-hateoas-filter-boolean',
  props: {
    filter: {
      type: Object,
      default () {
        return {
          id: null,
          title: null
        };
      }
    }
  },
  data () {
    return {
      selected: this.filter.selected
    };
  },
  watch: {
    selected: {
      immediate: true,
      handler (value) {
        this.$emit('change', value);
      }
    }
  }
};
</script>

<style scoped>

</style>
